import React from 'react';
import { Line } from 'react-konva';
import withMouseEvent from '../../hoc/withMouseEvent';

const Pencil = React.forwardRef(({ attrs }, ref) => {
  return (<Line {...attrs} ref={ref} globalCompositeOperation='source-over' />)
});

export default withMouseEvent(Pencil);
